import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { useDispatch } from 'react-redux'
import SelectableCheckboxList, {
  CheckboxList,
} from '../SettingsViews/SettingsComponents/SelectableCheckboxList'
import * as api from '../../../requests'
import '../SettingsViews/SettingsListView.scss'
import { setErrorToast, setSuccessToast } from '../../../actions'
import { useRequestData } from '../../../Utilities/hooks'
import { Spinner } from '../../Loaders/Loaders'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import { SUBROUTES } from '../../../App'

const OrderFilingTypeXref = () => {
  const dispatch = useDispatch()
  const imagePageTypes = useRequestData(api.GET_ALL_IMAGE_PAGE_TYPES, [], [])
  const formDefinitions = useRequestData(
    (cb, errCb) => api.GET_ALL_FORMS_BY_CATEGORY('Orders', cb, errCb),
    [],
    []
  )
  const appReports = useRequestData(api.GET_APP_REPORTS, [], [])
  const standingTypes = useRequestData(
    (cb, errCb) => api.GET_ACTIVE_BASIC_LOOKUP_TYPES('', 'StandingType', cb, errCb),
    [],
    []
  )

  const [orderFilingType, setOrderFilingType] = useState(0)
  const [orderFilingTypeOptions, setOrderFilingTypeOptions] = useState([])
  const [additionalParams, setAdditionalParams] = useState({})
  const [sourceTypeId, setSourceTypeId] = useState(0)
  const [sourceTypeOptions, setSourceTypeOptions] = useState([])
  const [statusTypeOptions, setStatusTypeOptions] = useState([])
  const [recordTypeOptions, setRecordTypeOptions] = useState([{ value: 0, label: 'All' }])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([{ value: 0, label: 'All' }])
  const [recordType, setRecordType] = useState(0)
  const [recordSubType, setRecordSubType] = useState(0)
  const [checkedOrderFilingTypeIds, setCheckedOrderFilingTypeIds] = useState([])
  const [allOrderXrefs, setAllOrderXrefs] = useState([])
  const [xRef, setXRef] = useState({ ...defaultDto })
  const [loadingXref, setLoadingXref] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [selectedMiscModuleId, setSelectedMiscModuleId] = useState(null)

  const allMiscModules = (SUBROUTES || [])
    .filter((r) => r.IsMiscRecordsType)
    .flatMap((r) => r.MiscRecordsModules || [])
    .sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))

  const miscModuleOptions = allMiscModules.map((m) => ({
    value: m.MiscellaneousModuleId,
    label: m.DisplayName,
  }))

  const selectedSourceType = sourceTypeOptions.find((x) => x.value == sourceTypeId)
  const isMiscellaneousSourceType = selectedSourceType
    ? selectedSourceType.label === 'Miscellaneous'
    : false

  const recordAccessUserRoles = useRequestData(
    (cb, errCb) => {
      if (isMiscellaneousSourceType) {
        if (selectedMiscModuleId) {
          api.GET_MISC_RECORD_ACCESS_ROLES_BY_MODULE(selectedMiscModuleId, cb, errCb)
        } else {
          cb([])
        }
      } else if (sourceTypeId && +sourceTypeId > 0) {
        api.GET_RECORD_ACCESS_USER_ROLES_BY_SOURCE_TYPE(sourceTypeId, cb, errCb)
      } else {
        cb([])
      }
    },
    [sourceTypeId, isMiscellaneousSourceType, selectedMiscModuleId],
    []
  )

  const filingFields = useRequestData(
    (cb, errCb) => {
      if (isMiscellaneousSourceType && selectedMiscModuleId) {
        api.GET_MISC_RECORDS_FILING_TYPE_FIELD_DETAILS(selectedMiscModuleId, cb, errCb)
      } else {
        cb([])
      }
    },
    [isMiscellaneousSourceType, selectedMiscModuleId],
    []
  )

  const [requirementsState, setRequirementsState] = useState({})

  const changeRequirementValue = (fieldName, value) => {
    setRequirementsState((prev) => ({ ...prev, [fieldName]: value }))
    setIsDirty(true)
  }

  const requirementFields = filingFields
    .filter((f) => f.ConfigurableAsFilingRequirement)
    .sort((a, b) => a.FieldDisplayName.localeCompare(b.FieldDisplayName))

  useEffect(() => {
    getLookupTypeOptions()
  }, [])

  const getLookupTypeOptions = () => {
    api.GET_ALL_BASIC_LOOKUP_TYPES(
      'OrderFilingType',
      (res) => {
        setOrderFilingTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      console.error
    )

    api.GET_CONFIGURED_ORDER_SOURCE_TYPES(
      false,
      (res) => {
        setSourceTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.ModuleName,
          })),
        ])
      },
      console.error
    )

    getAllOrdersXrefs()
  }

  const getAllOrdersXrefs = () => {
    api.GET_ORDERS_XREF(
      (res) => {
        setAllOrderXrefs(res)
      },
      (err) => {
        console.error(err)
      }
    )
  }

  useEffect(() => {
    const controller = new AbortController()
    getRecordTypeBasedOnSource(controller)
    getStatusTypesBasedOnSource(controller)
    getAdditionalParamsBasedOnSource(controller)
    return () => {
      controller.abort()
    }
  }, [sourceTypeId])

 const getAdditionalParamsBasedOnSource = (controller) => {
  if (sourceTypeId > 0) {
    setLoadingXref(true)
    api.GET_ADDITIONAL_ORDER_PARAMS(
      sourceTypeId,
      { signal: controller.signal },
      (res) => {
        if (res && res.length > 0) {
          setAdditionalParams(res)
        } else {
          setAdditionalParams([])
        }
        setLoadingXref(false)
      },
      (err) => {
        console.error(err)
        setAdditionalParams([])
        setLoadingXref(false)
      }
    )
  } else {
    setAdditionalParams([])
    setLoadingXref(false)
  }
}

  const getRecordTypeBasedOnSource = (controller) => {
    if (sourceTypeId > 0) {
      let sourceTypeName = sourceTypeOptions.find((x) => x.value == sourceTypeId)

      setLoadingXref(true)
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES_OPTIONS(
        sourceTypeName.label,
        'RecordType',
        { signal: controller.signal },
        (res) => {
          if (!res.isEmpty) {
            setRecordTypeOptions([
              { value: 0, label: 'All' },
              ...res.map((t) => ({
                value: t.Id,
                label: t.Name,
              })),
            ])
          }
          setLoadingXref(false)
        },
        (err) => {
          setRecordTypeOptions([{ value: 0, label: 'All' }])
          setLoadingXref(false)
        }
      )
    } else {
      setRecordType(0)
      setRecordTypeOptions([{ value: 0, label: 'All' }])
      setLoadingXref(false)
    }
  }

  const getStatusTypesBasedOnSource = (controller) => {
    if (sourceTypeId > 0) {
      let sourceTypeName = sourceTypeOptions.find((x) => x.value == sourceTypeId)

      setLoadingXref(true)
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES_OPTIONS(
        sourceTypeName.label,
        'StatusType',
        { signal: controller.signal },
        (res) => {
          if (!res.isEmpty) {
            setStatusTypeOptions([
              ...res.map((t) => ({
                Id: t.Id,
                Name: t.Name,
              })),
            ])
          }
          setLoadingXref(false)
        },
        (err) => {
          setStatusTypeOptions([])
          setLoadingXref(false)
        }
      )
    } else {
      setStatusTypeOptions([])
      setLoadingXref(false)
    }
  }

  useEffect(() => {
    const controller = new AbortController()
    getRecordSubTypeFromSelectedRecordType(controller)
    return () => {
      controller.abort()
    }
  }, [recordType])

  const getRecordSubTypeFromSelectedRecordType = (controller) => {
    setLoadingXref(true)
    if (sourceTypeId > 0) {
      let sourceTypeName = sourceTypeOptions.find((x) => x.value == sourceTypeId)

      api.GET_ACTIVE_BASIC_LOOKUP_TYPES_OPTIONS(
        sourceTypeName.label,
        'RecordSubType',
        { signal: controller.signal },
        (res) => {
          if (!res.isEmpty) {
            setRecordSubTypeOptions([
              { value: 0, label: 'All' },
              ...res.map((t) => ({
                value: t.Id,
                label: t.Name,
              })),
            ])
          }
          setLoadingXref(false)
        },
        (err) => {
          setRecordSubTypeOptions([{ value: 0, label: 'All' }])
          setLoadingXref(false)
        }
      )
    } else {
      setRecordSubType(0)
      setRecordSubTypeOptions([{ value: 0, label: 'All' }])
      setLoadingXref(false)
    }
  }

  const changeAdditionalParamValue = (paramName, value) => {
  const updatedParams = xRef.AdditionalParams || {}

  setXRef({
    ...xRef,
    AdditionalParams: {
      ...updatedParams,
      [paramName]: value,
    },
  })
  setIsDirty(true)
}

const getAdditionalParamValue = (paramName, defaultValue) => {
  const storedValue = (xRef.AdditionalParams || {})[paramName]
  return storedValue || defaultValue || ''
}

  const checkAndSetExistingFiling = () => {
    let orderCheckBox = []

    allOrderXrefs.forEach((orderXref) => {
      if (
        orderXref.SourceTypeId === Number(sourceTypeId) &&
        orderXref.SourceRecordTypeId === Number(recordType) &&
        orderXref.SourceRecordSubTypeId === Number(recordSubType) &&
        (!isMiscellaneousSourceType ||
          orderXref.MiscellaneousModuleId === Number(selectedMiscModuleId))
      ) {
        orderCheckBox.push(orderXref.OrderFilingTypeId)
      }
    })
    setCheckedOrderFilingTypeIds(orderCheckBox)
  }

  useEffect(() => {
    checkAndSetExistingFiling()
    clearDetails()
    setOrderFilingType(null)
  }, [sourceTypeId, recordType, recordSubType, selectedMiscModuleId, allOrderXrefs])

  const setDetailsOnActiveMapping = () => {
    const activeOrder = allOrderXrefs.find(
      (orderXref) =>
        orderXref.SourceTypeId === Number(sourceTypeId) &&
        orderXref.SourceRecordTypeId === Number(recordType) &&
        orderXref.SourceRecordSubTypeId === Number(recordSubType) &&
        orderXref.OrderFilingTypeId === Number(orderFilingType) &&
        (!isMiscellaneousSourceType ||
          orderXref.MiscellaneousModuleId === Number(selectedMiscModuleId))
    )

    setXRef(activeOrder ? activeOrder : { ...defaultDto })
    setRequirementsState(
      activeOrder && activeOrder.RequirementsToFileJson
        ? JSON.parse(activeOrder.RequirementsToFileJson)
        : {}
    )
  }

  useEffect(() => {
    if (orderFilingType) {
      setDetailsOnActiveMapping()
    }
  }, [orderFilingType])

  const clickRevert = () => {
    clearDetails()
    setRecordType(0)
    setRecordSubType(0)
    setSourceTypeId(0)
    setSelectedMiscModuleId(null)
    setOrderFilingType()
  }

  const clearDetails = () => {
    setIsDirty(false)
    setXRef({ ...defaultDto })
    setRequirementsState({})
  }

  const clickSave = () => {
    const existingXref = allOrderXrefs.find(
      (x) =>
        x.SourceTypeId === Number(sourceTypeId) &&
        x.SourceRecordTypeId === Number(recordType) &&
        x.SourceRecordSubTypeId === Number(recordSubType) &&
        x.OrderFilingTypeId === Number(orderFilingType) &&
        (!isMiscellaneousSourceType ||
          x.MiscellaneousModuleId === Number(selectedMiscModuleId))
    )

    const json = {
      ...xRef,
      SourceTypeId: Number(sourceTypeId),
      SourceRecordTypeId: Number(recordType),
      SourceRecordSubTypeId: Number(recordSubType),
      OrderFilingTypeId: Number(orderFilingType),
      OrderXrefId: xRef.OrderXrefId || 0,
      MiscellaneousModuleId: isMiscellaneousSourceType ? Number(selectedMiscModuleId) : null,
      PriorARStanding: Number(xRef.PriorARStanding),
      PriorAgentStanding: Number(xRef.PriorAgentStanding),
      PriorOtherStanding: Number(xRef.PriorOtherStanding),
      RequirementsToFileJson: isMiscellaneousSourceType
        ? JSON.stringify(requirementsState)
        : null,
    }
    // console.log(existingXref, json)
    setIsSaving(true)
    if (existingXref) {
      if (!checkedOrderFilingTypeIds.includes(Number(orderFilingType))) {
        // this only will delete one xref, and not all the unselected rows.
        api.DELETE_ORDER_XREF(
          existingXref.OrderXrefId,
          (res) => {
            setIsSaving(false)
            setIsDirty(false)
            setXRef({ ...defaultDto })
            setRequirementsState({})
            setRecordType(0)
            setRecordSubType(0)
            setSourceTypeId(0)
            setSelectedMiscModuleId(null)
            getAllOrdersXrefs()
            dispatch(setSuccessToast('Xref Deleted successfully.'))
          },
          (err) => {
            console.error(err)
            setIsSaving(false)
            if (err.DisplayToUser === true && (err.Message || '') !== '') {
              dispatch(setErrorToast(err.Message))
            } else {
              dispatch(setErrorToast('Failed to save setting.'))
            }
          }
        )
      } else {
        api.UPDATE_ORDER_XREF(
          json,
          (res) => {
            setIsSaving(false)
            setIsDirty(false)
            getAllOrdersXrefs()
            dispatch(setSuccessToast('Saved Setting(s) successfully.'))
          },
          (err) => {
            console.error(err)
            setIsSaving(false)
            if (err.DisplayToUser === true && (err.Message || '') !== '') {
              dispatch(setErrorToast(err.Message))
            } else {
              dispatch(setErrorToast('Failed to save setting.'))
            }
          }
        )
      }
    } else {
      api.CREATE_NEW_ORDER_XREF(
        json,
        (res) => {
          setIsSaving(false)
          setIsDirty(false)
          getAllOrdersXrefs()
          dispatch(setSuccessToast('Saved Setting(s) successfully.'))
        },
        (err) => {
          console.error(err)
          setIsSaving(false)
          if (err.DisplayToUser === true && (err.Message || '') !== '') {
            dispatch(setErrorToast(err.Message))
          } else {
            dispatch(setErrorToast('Failed to save setting.'))
          }
        }
      )
    }
  }

  const changeXrefValue = (property, value) => {
    setXRef({ ...xRef, [property]: value })
    setIsDirty(true)
  }

  return (
    <div className="settings-list-view">
      <h2>Order Filing Type Mappings</h2>
      <div className="settings-content">
        <div
          className="settings-left-column"
          style={{
            margin: '0 0 0 10px',
            display: 'flex',
            gap: '20px',
          }}
        >
          <SelectBox
            label="Source Type"
            value={sourceTypeId || ''}
            onChange={setSourceTypeId}
            options={sourceTypeOptions}
            disabled={isDirty ? true : undefined}
            description={isDirty ? 'Save or Revert changes to modify.' : undefined}
            noPlaceholder
          />
          {!isMiscellaneousSourceType && (
            <SelectBox
              label="Record Type"
              noPlaceholder
              value={recordType || ''}
              onChange={(val) => {
                setRecordType(val)
                if (!Number(val)) {
                  setRecordSubType(0)
                }
              }}
              options={recordTypeOptions}
              disabled={sourceTypeId > 0 ? (isDirty ? true : undefined) : true}
              description={
                sourceTypeId > 0
                  ? isDirty
                    ? 'Save or Revert changes to modify.'
                    : undefined
                  : 'Select a Source Type to continue.'
              }
            />
          )}
          {!isMiscellaneousSourceType && (
            <SelectBox
              label="Record Sub Type"
              noPlaceholder
              value={recordSubType || ''}
              onChange={(val) => {
                setRecordSubType(val)
              }}
              options={recordSubTypeOptions}
              disabled={sourceTypeId > 0 && Number(recordType) > 0 ? (isDirty ? true : undefined) : true}
              description={
                sourceTypeId > 0
                  ? Number(recordType) > 0
                    ? isDirty
                      ? 'Save or Revert changes to modify.'
                      : undefined
                    : 'Select a Record Type to continue.'
                  : 'Select a Source Type to continue.'
              }
            />
          )}
          {isMiscellaneousSourceType && (
            <SelectBox
              label="Module"
              noPlaceholder
              value={selectedMiscModuleId || ''}
              onChange={(val) => {
                setSelectedMiscModuleId(val)
              }}
              options={miscModuleOptions}
              disabled={isDirty ? true : undefined}
              description={isDirty ? 'Save or Revert changes to modify.' : undefined}
            />
          )}
          <SelectableCheckboxList
            label={`Order Filing Types`}
            items={orderFilingTypeOptions.map((orderFilingType) => ({
              id: orderFilingType.value,
              label: orderFilingType.label,
            }))}
            checked={checkedOrderFilingTypeIds}
            setChecked={(ids) => {
              setCheckedOrderFilingTypeIds(ids)
              setIsDirty(true)
            }}
            activeId={orderFilingType}
            setActiveId={(id) => {
              setOrderFilingType(id)
            }}
            disabled={sourceTypeId > -1 ? (isDirty ? true : undefined) : true}
          />
        </div>
        <div
          className="properties-list scrollable"
          style={{
            flexDirection: 'column',
            // margin: '0 0 0 20px',
            width: '100%',
            maxWidth: '600px',
            transition: 'width .3s ease-in-out',
          }}
        >
          {/* DETAILS */}
          <h3
            style={{
              textDecoration: 'underline',
              display: 'flex',
              alignSelf: 'center',
              fontWeight: 'bold',
            }}
          >
            Details
          </h3>

          <div
            style={{
              gap: '20px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <SelectBox
              label="Image Page Type"
              options={imagePageTypes
                .map((imagePageType) => {
                  return {
                    label: imagePageType.Name,
                    value: imagePageType.Id,
                  }
                })
                .sort((a, b) => {
                  return a.label > b.label ? 1 : -1
                })}
              onChange={(value) => {
                changeXrefValue('ImagePageTypeId', value)
              }}
              value={xRef.ImagePageTypeId || ''}
              disabled={!orderFilingType}
            />

            <SelectBox
              label="Form Title"
              options={formDefinitions
                .map((formDefinition) => {
                  return {
                    label: formDefinition.Title,
                    value: formDefinition.FormDefinitionId,
                  }
                })
                .sort((a, b) => {
                  return a.label > b.label ? 1 : -1
                })}
              onChange={(value) => {
                changeXrefValue('FormDefinitionId', value)
              }}
              value={xRef.FormDefinitionId || ''}
              disabled={!orderFilingType}
            />

            <CheckboxList
              label="Record Access Roles Permitted to File (Leave blank to allow open filing)"
              items={(isMiscellaneousSourceType
                ? recordAccessUserRoles
                : recordAccessUserRoles.filter(
                    (x) => x.CanFileAmendments || x.CanFileSpecialAmendments
                  )
              )
                .map((role) => ({
                  id: role.RecordAccessUserRoleId,
                  label: role.Name,
                }))
                .sort((a, b) => (a.label > b.label ? 1 : -1))}
              checkedIds={xRef.PermittedRecordAccessUserRoleIds || []}
              setChecked={(ids) => {
                changeXrefValue('PermittedRecordAccessUserRoleIds', ids)
              }}
              disabled={
                !orderFilingType ||
                (isMiscellaneousSourceType ? !selectedMiscModuleId : sourceTypeId <= 0)
              }
            />

            {!isMiscellaneousSourceType && (
              <CheckboxList
                label={'Status to File'}
                items={statusTypeOptions.map((type) => ({ id: type.Id, label: type.Name }))}
                checkedIds={xRef.SourceStatusesToFile || []}
                setChecked={(ids) => {
                  changeXrefValue('SourceStatusesToFile', ids)
                }}
                disabled={!orderFilingType || sourceTypeId <= 0}
              />
            )}

            {isMiscellaneousSourceType && (
              <>
                <h3
                  style={{
                    textDecoration: 'underline',
                    display: 'flex',
                    alignSelf: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  Requirements to File
                </h3>
                {requirementFields.map((field) => {
                  const fieldKey = field.FieldName
                  const currentValue = requirementsState[fieldKey]
                  if (+field.DataType === 3 || +field.DataType === 4) {
                    return (
                      <TextInput
                        key={fieldKey}
                        label={`Allow days before ${field.FieldDisplayName}`}
                        type="number"
                        value={currentValue != null ? currentValue : ''}
                        onChange={(e) =>
                          changeRequirementValue(
                            fieldKey,
                            e.target.value === '' ? null : parseInt(e.target.value, 10)
                          )
                        }
                        disabled={!orderFilingType}
                      />
                    )
                  }
                  if (+field.DataType === 2) {
                    return (
                      <SelectBox
                        key={fieldKey}
                        label={field.FieldDisplayName}
                        options={[
                          { value: 'true', label: 'True' },
                          { value: 'false', label: 'False' },
                          { value: '', label: 'N/A' },
                        ]}
                        value={
                          currentValue === true
                            ? 'true'
                            : currentValue === false
                            ? 'false'
                            : ''
                        }
                        onChange={(val) =>
                          changeRequirementValue(
                            fieldKey,
                            val === 'true' ? true : val === 'false' ? false : null
                          )
                        }
                        noPlaceholder
                        disabled={!orderFilingType}
                      />
                    )
                  }
                  if (+field.DataType === 5) {
                    const lookupItems = (() => {
                      try {
                        return JSON.parse(field.LookupTypeValuesJson || '[]')
                      } catch {
                        return []
                      }
                    })().map((item) => ({ id: item.value, label: item.label }))
                    return (
                      <CheckboxList
                        key={fieldKey}
                        label={`${field.FieldDisplayName} (Leave blank to allow open filing)`}
                        items={lookupItems}
                        checkedIds={Array.isArray(currentValue) ? currentValue : []}
                        setChecked={(ids) => changeRequirementValue(fieldKey, ids)}
                        disabled={!orderFilingType}
                      />
                    )
                  }
                  return null
                })}
              </>
            )}

            {/* Dynamic Additional Params */}
            {additionalParams.length > 0 &&
              additionalParams.map((param) => {
                if (param.Type === 'Standing') {
                  // StandingType lookup Names are for display (e.g. "Not Good") and don't always match the
                  // backend enum's own spelling ("NotGood") exactly, so the value sent back must strip whitespace
                  // to reconstruct the exact enum member name - the label keeps the original spacing.
                  const options = standingTypes
                    .map((cd) => ({
                      label: cd.Name,
                      value: cd.Name.replace(/\s+/g, ''),
                    }))
                    .sort((a, b) => (a.label > b.label ? 1 : -1))
                  const noneOption = options.find((o) => o.value === 'None')
                  return (
                    <SelectBox
                      key={param.Name}
                      label={param.Label}
                      options={options}
                      onChange={(value) => {
                        changeAdditionalParamValue(param.Name, value)
                      }}
                      value={getAdditionalParamValue(param.Name, noneOption ? noneOption.value : '')}
                      disabled={!orderFilingType || sourceTypeId <= 0}
                      noPlaceholder
                    />
                  )
                }
                return null
              })}

            <Checkbox
              label="Include Original Image with Approval Stamp for Paper Filings"
              checked={xRef.IncludeImageForPaperFiling || false}
              onChange={(checked) => {
                changeXrefValue('IncludeImageForPaperFiling', checked)
              }}
              disabled={!orderFilingType}
            />

            <CheckboxList
              label={'Generated Reports'}
              items={appReports
                .map((appReport) => ({ id: appReport.Id, label: appReport.Name }))
                .sort((a, b) => {
                  return a.label > b.label ? 1 : -1
                })}
              checkedIds={xRef.ReportIds || []}
              setChecked={(ids) => {
                changeXrefValue('ReportIds', ids)
              }}
              disabled={!orderFilingType}
            />
          </div>

          <div className="button-wrapper" style={{ marginTop: '20px' }}>
            {(loadingXref || isSaving) && (
              <div className="loading-type">
                <Spinner size="small" themeColor="dark-neutral" />
              </div>
            )}
            <ContextButton
              variant="danger"
              disabled={!isDirty && !isSaving}
              leftIcon={
                <div className="checkmark-wrapper left">
                  <Revert />
                </div>
              }
              onClick={clickRevert}
            >
              Revert
            </ContextButton>
            <ContextButton
              variant="primary"
              disabled={(!isDirty && !isSaving) || (isMiscellaneousSourceType && !selectedMiscModuleId)}
              rightIcon={
                <div className="checkmark-wrapper right">
                  <RightArrow />
                </div>
              }
              onClick={clickSave}
            >
              Save
            </ContextButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderFilingTypeXref

const defaultDto = {
  OrderXrefId: null,
  SourceTypeId: null,
  OrderFilingTypeId: 0,
  SourceRecordTypeId: 0,
  SourceRecordSubTypeId: null,
  SourceStatusesToFile: [],
  ImagePageTypeId: null,
  PermittedRecordAccessUserRoleIds: [],
  FormDefinitionId: null,
  IncludeImageForPaperFiling: false,
  ReportIds: [],
  AdditionalParams: {},
  MiscellaneousModuleId: null,
  RequirementsToFileJson: null,
}
